import { axiosClient } from 'www/utils'
import { ApiTownInfoParamsGet, ApiTownInfoResponseGet } from 'www/vue_components/common/SearchBar/api/apiTownInfo.types'

export default {
  get(params: ApiTownInfoParamsGet) {
    return axiosClient.get<ApiTownInfoResponseGet>('/api/town/info/', {
      params,
    })
  },
}
